export default "__VITE_ASSET__BB7QM2$v__"